<form [formGroup]="form" [id]="pageCode + '_searchForm'">
    <div class="p-fluid formgrid grid">
        <hvl-form-item class="col-12 md:col-6 lg:col-2" key="perObjectDefinitionText" [label]="'orgPicker.organizationText' | translate">
            <input id="perObjectDefinitionText" type="text" formControlName="perObjectDefinitionText" pInputText      (keyup.enter)="onKeyDownEvent()" />
        </hvl-form-item>
        <hvl-form-item class="col-12 md:col-6 lg:col-2" key="perobjectdefinationpid" [label]="'orgPicker.organizationParent' | translate">
            <p-autoComplete
                minLength="3"
                placeholder="{{ 'autocompleteSearchText' | translate }}"
                [suggestions]="list"
                (completeMethod)="onSearch($event)"
                (onSelect)="onSelect($event?.value)"
                (onClear)="onClear()"
                field="perObjectDefinitionText"
                showClear="true"
                [showEmptyMessage]="true"
                emptyMessage="{{ 'noRecordsFound' | translate }}"
            >
                <ng-template let-item pTemplate="item">
                    <div [innerHTML]="item.perObjectDefinitionUnitCode + ' - ' + item.perObjectDefinitionText"></div>
                </ng-template>
            </p-autoComplete>
        </hvl-form-item>
        <hvl-form-item *ngIf="showStaffFullnessStatus" class="col-12 md:col-6 lg:col-2" key="staffFullnessStatus" [label]="'orgPicker.staffFullnessStatus' | translate">
            <p-dropdown uiKovanDropdown
                [filter]="true"
                class="form-control"
                [options]="staffFullnessStatusEnumList"
                [optionLabel]="'label'"
                [optionValue]="'value'"
                [showClear]="true"
                id="staffFullnessStatus"
                formControlName="staffFullnessStatus"
                placeholder="{{ 'placeHolder' | translate }}"
            ></p-dropdown>
        </hvl-form-item>
        <hvl-form-item  class="col-12 md:col-6 lg:col-2" key="provinceId" [label]="'orgPicker.province' | translate">
            <p-dropdown uiKovanDropdown
                        placeholder="{{ 'placeHolder' | translate }}"
                        id="provinceId"
                        name="provinceId"
                        formControlName="provinceId"
                        class="form-control"
                        filter="true"
                        (onChange)="fetchSubProvinceList()"
                        [options]="provinceList"
                        [optionLabel]="'text'"
                        [optionValue]="'id'"
            ></p-dropdown>
        </hvl-form-item>
        <hvl-form-item  class="col-12 md:col-6 lg:col-2" key="subProvinceId" [label]="'orgPicker.subprovince' | translate">
            <p-dropdown uiKovanDropdown
                        placeholder="{{ 'placeHolder' | translate }}"
                        id="subprovinceId"
                        name="subprovinceId"
                        formControlName="subprovinceId"
                        class="form-control"
                        filter="true"
                        [options]="subProvinceList"
                        [optionLabel]="'text'"
                        [optionValue]="'id'"
            ></p-dropdown>

        </hvl-form-item>
        <hvl-form-item class="col-4" [label]="'orgPicker.managerName' | translate">
            <input id="managerName" name="managerName" pInputText type="text" formControlName="managerName" />
        </hvl-form-item>
    </div>
</form>
